export const agentVoiceOptions = [
  { value: 'Zephyr', title: 'Փառանձեմ', subtitle: 'Դրական, աշխույժ ձայն' },
  { value: 'Puck', title: 'Արգամ', subtitle: 'Թեթև, էներգետիկ ինտոնացիա' },
  { value: 'Charon', title: 'Բաղդասար', subtitle: 'Խորը, հանգիստ, կշռադատված' },
  { value: 'Kore', title: 'Որմիզդուխտ', subtitle: 'Երիտասարդ, հավասարակշռված ձայն' },
];

export const DEFAULT_AGENT_VOICE = agentVoiceOptions[0].value;

export const getAgentVoiceOption = (value) => (
  agentVoiceOptions.find((option) => option.value === value) || agentVoiceOptions[0]
);
